/**
 * My Storefront dashboard copy + module metadata (from design handoff seed).
 * Icons: Font Awesome classes (project standard); not lucide.
 */

export const STOREFRONT_DASHBOARD = {
  hero: {
    eyebrow: "Owner Command Room · Preview",
    title: "My Storefront",
    subtitle: "Build your legacy in Oshar's markets.",
    description:
      "Your NFT real estate unlocks merchant publishing, product listings, commerce tools, and buyer access when marketplace operations go live.",
    statusTitle: "Store Publishing Locked",
    statusBody:
      "Marketplace operations are offline. Seller routes deep-link to this hub during the visual lockdown.",
  },
  activeUtility: {
    sectionTitle: "Your Active Storefront Utility",
    parcel: "Auric Spire — Parcel 07",
    badge: "Coming Soon",
    district: "Skyward Terrace",
    propertyClass: "Luxury residential tower",
    commerceType: "Digital art & experiences",
    utility: "Storefront publishing",
    status: "Coming Soon",
    description:
      "When marketplace operations go live, your Treydora VR Real Estate NFT will unlock storefront publishing tied to this parcel.",
  },
  modules: [
    { title: "Store Profile", iconClass: "fa-store", description: "Branding, banners, and storefront story." },
    { title: "Product Listings", iconClass: "fa-box-open", description: "Draft, schedule, and merchandise SKUs." },
    { title: "Pricing", iconClass: "fa-dollar-sign", description: "Card lanes, bundles, and fee previews." },
    { title: "Orders", iconClass: "fa-receipt", description: "Fulfillment queue and buyer messaging." },
    { title: "Analytics", iconClass: "fa-chart-bar", description: "Traffic, conversion, and cohort views." },
    { title: "Payouts", iconClass: "fa-landmark", description: "Statements and treasury routing." },
  ],
  rightRail: {
    storefrontStatus: {
      title: "Storefront Status",
      rank: "Founder Level 7",
      xp: "12,400 / 15,000 XP",
      dailyStreak: "7 Days",
      questXp: "24,975 XP",
      achievementsCta: "View Achievements",
    },
    launchChecklist: {
      title: "Launch Checklist",
      items: ["Marketplace Operations", "Merchant Tools Access", "Storefront Publishing"],
      updatesCta: "View All Updates",
    },
    parcelUtility: {
      title: "Parcel Utility",
      chip: "NFT Real Estate Utility",
      body:
        "Your storefront utility will enable commerce tools and publishing for this parcel when marketplace operations go live.",
      learnCta: "Learn More",
    },
  },
};
